<div class="ticket-content">
  <ng-template #ticketContainer></ng-template>
</div>


